import { createPostAsyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityMonitorsAllSlice } from '../monitors/all/get';
import { getCoreDataSecurityMonitorsByApplicationSlice } from '../monitors/application/get';
import { getCoreDataSecurityMonitorsSlice } from '../monitors/get';
import { postDataSecurityActionTemplate } from '@api/data-security';

export const postCoreDataSecurityActionTemplateSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [
			getCoreDataSecurityMonitorsSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitors,
			getCoreDataSecurityMonitorsAllSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitorsAll,
			// eslint-disable-next-line max-len
			getCoreDataSecurityMonitorsByApplicationSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitorsByApplication
		]
	},
	name: 'CoreDataSecurityActionTemplate',
	receive: false,
	request: true,
	requestHandler: postDataSecurityActionTemplate
});
